import React from 'react'

export const MobileLogo = ({}) => (
  <div className="logo-mobile">
    <svg
      width="34px"
      height="34px"
      viewBox="0 0 17 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Airlift-mobile-icon">
        <polygon points="2.83297868 9.5 0 14.2496567 2.83297868 19 8.50035465 19 11.3333333 14.2496567 5.66666667 14.2496567 8.50035465 9.5" />
        <polygon points="8.23051338 0 5.3968254 4.75 13.8971801 19 16.7301587 14.25" />
      </g>
    </svg>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/common/logo.js